export interface ProviderSettings {
  /**
   * Does this Gift Card provider record individual transactions against a Gift Card?
   */
  recordsTransactions: boolean
  terms: {
    /**
     * The provider's term for 'card', all lowercase.
     */
    card: string
    /**
     * The provider's term for the code or number, all lowercase.
     */
    code: string
    /**
     * The provider's term for 'gift card', all lowercase.
     */
    giftCard: string
    /**
     * The provider's term for 'gift card code', all lowercase.
     */
    giftCardCode: string
  }
}

export const GIFTCARD_PROVIDER_SETTINGS: {
  [key: string]: ProviderSettings
} = {
  BIGCOMMERCE: {
    recordsTransactions: false,
    terms: {
      card: 'certificate',
      code: 'code',
      giftCard: 'gift certificate',
      giftCardCode: 'gift certificate code',
    },
  },
  BALANCES: {
    recordsTransactions: true,
    terms: {
      card: 'card',
      code: 'number',
      giftCard: 'gift card',
      giftCardCode: 'gift card number',
    },
  },
}
